import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Cocktail, Martini, Sad } from '../../utils';

import { StatusMessageContainer, MessageDescription, MessageIcon } from './styles';

const renderIcon = status => {
  switch (Number(status)) {
    case 0:
      return <Cocktail />;
    case 2:
    case 3:
    case 4:
      return <Martini />;
    default:
      return <Sad />;
  }
};

const renderDescription = status => {
  switch (Number(status)) {
    case 0:
    case 4:
      return 'Thanks for booking with us! Here is a receipt for your purchase and check-in instructions.';
    case 2:
      return 'Hope you had a great time!';
    default:
      return 'We missed you! Hope to see you here another time.';
  }
};

const BookingStatusMessage = ({ status, userInfo, message  }) => {
 
  return(
  <StatusMessageContainer>
    <MessageIcon>
      {renderIcon(status)}
    </MessageIcon>
    <MessageDescription>
      <b>Hi{userInfo && ` ${userInfo.firstName ? userInfo.firstName.trim() : 'Unknown Guest'}`}!</b>&nbsp;
      {!message ? renderDescription(status) : message}
    </MessageDescription>
     
 
    
    
 

  </StatusMessageContainer>
)};

BookingStatusMessage.propTypes = {
  status: PropTypes.number,
  userInfo: PropTypes.instanceOf(Object),
  message: PropTypes.string,
};

const mapStateToProps = state => ({
  userInfo: state.user.userData,
});

export default connect(mapStateToProps)(BookingStatusMessage);
